import { defineStore } from 'pinia'
import Cookies from "js-cookie";

export const UserGUIDStore = defineStore('guid_user', {
    state: () => {
        if (Cookies.get('user')) {
            return {
                guid_user: Cookies.get('user')
            }
        } else {
            return {
                guid_user: null
            }
        }
    },
    actions: {
        get() {
            return this.guid_user
        },
        set(value) {
            this.guid_user = value
        },
        clear(){
            Cookies.remove('user')
            this.guid_user = null
        }
    }
})

export const TokenGUIDStore = defineStore('guid_token', {
    state: () => {
        if (Cookies.get('token')) {
            return {
                guid_token: Cookies.get('token')
            }
        } else {
            return {
                guid_token: null
            }
        }
    },
    actions: {
        get() {
            return this.guid_token
        },
        set(value) {
            this.guid_token = value
        },
        clear(){
            Cookies.remove('token')
            this.guid_token = null
        }
    }
})